
export default {
  name: 'Boutiques',
  async asyncData({ $storyblok }) {
    const boutiques = await $storyblok.getStories({ with_tag: 'boutique' })
    return {
      boutiques
    }
  },
  head() {
    return {
      title: "Les Commerçants Grand'Rue"
    }
  }
}
